import { System } from '@ecs/System';
import { Shield } from '@components/Shield';

export class ShieldSystem extends System {
  update(deltaTime: number): void {
    const currentTime = Date.now();
    const entities = this.getEntitiesWithComponents(Shield);

    for (const entity of entities) {
      const shield = entity.getComponent(Shield)!;

      // Check if shield should regenerate
      if (shield.current < shield.max) {
        const timeSinceDamage = currentTime - shield.lastDamageTime;
        
        // Only regenerate if enough time has passed since last damage
        if (timeSinceDamage >= shield.regenDelay) {
          shield.current = Math.min(
            shield.max,
            shield.current + shield.regenRate * (deltaTime / 1000)
          );
          
          // Reactivate shield when it regenerates from 0
          if (shield.current > 0 && !shield.isActive) {
            shield.isActive = true;
          }
        }
      }
    }
  }
}